import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Lazy load components
const CustomerList = lazy(() => import('../Pages/CustomerList'));
const AddCustomer = lazy(() => import('../Pages/AddCustomer'));
const EditCustomer = lazy(() => import('../Pages/EditCustomer'));
const CustomerView = lazy(() => import('../Pages/CustomerView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/customer.scss';

function CustomerRoute() {
  const history = useHistory();
  return (
    <Switch>
      <Route
        exact
        path="/:lng/user/customer"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <CustomerList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/user/customer/list"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <CustomerList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/user/customer/add"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <AddCustomer history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/user/customer/edit/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <EditCustomer history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
      <Route
        exact
        path="/:lng/user/customer/view/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <CustomerView history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
    </Switch>
  );
};

export default CustomerRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
